import React from 'react';

const DocIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 14">
    <path d="M8.967.095A.5.5 0 0 1 9.092.2L11.217 3h-2.25V.095Zm0 3.905a1 1 0 0 1-1-1V0h-6a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5V4h-2.5Z" /><path d="M3.644 9.985v-.61h.327c.207 0 .333.118.333.307 0 .183-.126.303-.333.303h-.327Zm.378.357c.42 0 .699-.276.699-.663 0-.384-.28-.663-.7-.663h-.794v2.127h.414v-.801h.38Zm1.58.417v-1.36h.332c.348 0 .636.22.636.682 0 .462-.29.678-.639.678h-.33Zm.344.384c.606 0 1.053-.39 1.053-1.062s-.444-1.065-1.05-1.065h-.762v2.127h.76Zm1.98 0v-.828h.824v-.381h-.828v-.525h.93v-.393H7.508v2.127h.417Z" fill="#fff" />
  </svg>
);

export default DocIcon;